import {Component} from "@angular/core";
import {ExtraSearchModel} from "../extra-search.model";
import {ExtraEntityModel} from "../extra-entity.model";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-extras-search-page",
    templateUrl: "./extra-search-page.component.html",
    providers: [provideSearchModel(ExtraSearchModel), provideEntityModel(ExtraEntityModel)]
})
export class ExtraSearchPageComponent extends AbstractSearchPage {


}
